/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import USwitch from '@ultra/share/components/USwitch/index.vue';
import { apiUsdkGetChannelH5List, apiUsdkUpdateH5Channel } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  __name: 'configModal',
  emits: ['refresh'],
  setup(__props, {
    expose,
    emit
  }) {
    const dialogVisible = ref(false);
    const dataForm = ref();
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const handleOk = async () => {
      let pids = [];
      tableData.value.forEach(item => {
        if (item.status) {
          pids.push(item.id);
        }
      });
      const res = await apiUsdkUpdateH5Channel({
        cid: dataForm.value.cid,
        gid: dataForm.value.gid,
        pids: pids.join(',')
      });
      if (res.code === 0) {
        handleClose();
        emit('refresh');
      }
    };
    const columns = [{
      label: '页面ID',
      prop: 'webId',
      width: 120
    }, {
      label: '功能说明',
      prop: 'name',
      width: 200
    }, {
      label: '跳转地址',
      prop: 'webUrl'
    }, {
      label: '渠道生效状态',
      prop: 'status',
      slot: 'status',
      width: 120
    }];
    const getTableData = async () => {
      const res = await apiUsdkGetChannelH5List({
        gid: dataForm.value.gid,
        cid: dataForm.value.cid
      });
      if (res.code === 0) {
        const data = res.data.h5s;
        const pids = res.data.pids;
        data.forEach(item => {
          if (pids.includes(item.id)) {
            item.status = 1;
          } else {
            item.stauts = 0;
          }
        });
        tableData.value = data;
      }
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    const showModal = payload => {
      if (payload.data) {
        dataForm.value = payload.data;
      }
      getTableData();
      dialogVisible.value = true;
    };
    expose({
      showModal
    });
    return (_ctx, _cache) => {
      var _unref2;
      const _component_el_button = __unplugin_components_0;
      const _component_el_dialog = __unplugin_components_1;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        width: "900px",
        title: `渠道H5配置-${(_unref2 = _unref(dataForm)) === null || _unref2 === void 0 ? void 0 : _unref2.channelTitle}渠道`,
        "before-close": () => handleClose()
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => handleClose())
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = $event => handleOk())
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(UTable, {
          options: columns,
          "row-key": "cid",
          pagination: false,
          data: _unref(tableData),
          loading: _unref(tableLoading)
        }, {
          status: _withCtx(({
            scope
          }) => [_createVNode(USwitch, {
            modelValue: scope.row.status,
            "onUpdate:modelValue": $event => scope.row.status = $event
          }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
          _: 1
        }, 8, ["data", "loading"])])]),
        _: 1
      }, 8, ["modelValue", "title", "before-close"]);
    };
  }
});